<template>
  <div class="loader-container">
  </div>
</template>

<script>
export default {
  name: "Loader"
}
</script>

<style scoped lang="scss">
  .loader-container {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: inline-block;
    border-top: 3px solid #FFF;
    border-right: 3px solid transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @media (max-width: 1600px) {
    .loader-container {
      width: 32px;
      height: 32px;
    }
  }
  @media (max-height: 800px) {
    .loader-container {
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .loader-container {
      width: 32px;
      height: 32px;
    }
  }

  @media (max-width: 1133px) {
    .loader-container {
      width: 24px;
      height: 24px;
    }
  }

  @media(min-width: 3025px) {
    .loader-container {
      width: 42px;
      height: 42px;
    }
  }
</style>